export default "__VITE_ASSET__DDpAGES7__"